module.exports = __webpack_public_path__ + "img/7f1387411b0c6c316fcf1a7a4721e704.png";